<template>
<div class="chapter">
<div class="inner_page">
<p class="p3">Muchas gracias a Laura, mi lectora alfa,</p>
<p class="p4">por las sugerencias, ánimo y exigencias.</p>
<p class="p5"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005.vue?73fce744